import { render, staticRenderFns } from "./comp_CheckoutStep-payment-TvMutual--active.vue?vue&type=template&id=97374b38&scoped=true"
import script from "./comp_CheckoutStep-payment-TvMutual--active.vue?vue&type=script&lang=js"
export * from "./comp_CheckoutStep-payment-TvMutual--active.vue?vue&type=script&lang=js"
import style0 from "./comp_CheckoutStep-payment-TvMutual--active.vue?vue&type=style&index=0&id=97374b38&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97374b38",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VRadio,VRadioGroup})
